import React from 'react';

import { Divider, Row, Col } from 'antd';
import { getFullName } from 'utils/personUtils';
import { ProfileCorporateTimesheetApproverInfoModel } from 'api/backofficeApiClient';

type Props = {
  timesheetApprover: ProfileCorporateTimesheetApproverInfoModel;
};

export default function TimesheetApproverCard(props: Props) {
  const { timesheetApprover } = props;

  const timesheetApproverName = getFullName(
    timesheetApprover.firstName,
    timesheetApprover.lastName,
  );

  return (
    <div className="divider-box">
      <div className="content-wrapper">
        <Row gutter={[4, 4]} className="titled-sheet">
          {!!timesheetApproverName && (
            <Col xs={24} md={12}>
              <div className="title">TS approver:</div>
              <div>{timesheetApproverName}</div>
            </Col>
          )}

          {!!timesheetApprover?.email && (
            <Col xs={24} md={12}>
              <div className="title">Email:</div>
              <div>{timesheetApprover?.email}</div>
            </Col>
          )}

          {!!timesheetApprover?.phoneNumber && (
            <Col xs={24} md={12}>
              <div className="title">Phone number:</div>
              <div>{timesheetApprover?.phoneNumber}</div>
            </Col>
          )}
        </Row>
      </div>
      <Divider className="card-divider no-margin" />
    </div>
  );
}
